module.exports = __webpack_public_path__ + "img/party-2011-chorus.bd736896.jpg";